<template>
  <div class="kpList">
    <el-tabs class="header" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="待开票" name="1"></el-tab-pane>
      <el-tab-pane label="已开票" name="2"></el-tab-pane>
    </el-tabs>
    <section >
      <el-radio-group v-if="list.length&&activeName==1" style="width: 100%;" v-model="checkList" @change="checkedChange">
        <el-radio v-for="(item,ind) in list" class="list_card" style="display: flex;align-items: center" :disabled="Boolean(item.fplb)" :key="ind" :label="item">
          <p class="flex_p">
            <span>缴费金额：{{item.sfje}} 元</span> <span style="color: orange">{{item.fplb}}</span>
          </p>
          <p>
            缴费日期：{{item.sfrq}}
          </p>
        </el-radio>
      </el-radio-group>
      <p class="no_data" v-if="(!list.length&&activeName==1)||(!fpList.length&&activeName==2)">
        暂无业务记录
      </p>
      <li v-if="fpList.length&&activeName==2" class="list_card" v-for="item in fpList">
        <p>购买方名称：{{item.gmfMc}}</p>
        <p class="flex_p">
          <span>
            推送方式：{{getTsfs(item.tsfs)}}
          </span>
          <span :class="getColor(item.shzt)">
            {{item.shzt}}
          </span>
        </p>
        <p>
          发票类别：{{item.fplb}}
        </p>
        <p>
          购买方地址：{{item.gmfDzdh}}
        </p>
      </li>
    </section>
    <footer v-if="list.length&&activeName==1">
      <!--      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="checkAllChange">-->
      <!--        全选-->
      <!--      </el-checkbox>-->
      <span></span>
      <span>
        金额：{{kpje}} 元
      <el-button :type="this.kpje<=0?'':'primary'" :disabled="this.kpje<=0" style="margin-left: 10px;" @click="submitKp">
        开票
      </el-button>
      </span>
    </footer>
  </div>
</template>

<script>
  import { findPayToKp,getYwjl } from "@/api";
  import {tsfs} from "@/constants";
  import {validSlsx} from "@/utils";

  export default {
    data() {
      return {
        list: [],
        checkList: null,
        kpje: 0,
        fpList: [],
        activeName: '1',
        czbh: ''
      }
    },
    mounted() {
      this.getList()
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
      getColor(type) {
        let className = 'text_green'
        if(type=='审核中') {
          className = 'text_orange'
        } else if(type=='未通过') {
          className = 'text_red'
        }
        return className
      },
      checkedChange(){
        this.getKpje()
      },
      getTsfs(item) {
        let val = '-'
        tsfs.map(v=>{
          if(v.value==item) {
            val = v.label
          }
        })
        return val
      },
      getKpje() {
        this.kpje = this.checkList.sfje
        this.czbh = this.checkList.czbh
      },
      getList() {
        let params = {
          customerId: this.$route.query.userId
        }
        findPayToKp(params).then(res=>{
          this.list = res.data
        })
        const ywparams = {
          customerId: this.$route.query.userId,
          type: 'fp'
        }
        getYwjl(ywparams).then(res=>{
          this.fpList = res.data.fpList
        })
      },
      submitKp() {
        let params = {
          customerId: this.$route.query.userId,
          kpje: this.kpje
        }
        if(validSlsx('开票')) {
          this.$router.push({
            path: '/kjfp',
            query: {...this.$route.query, czbh: this.czbh}
          })
        }
      }
    }
  }
</script>

<style>
  .kpList{
    height: 90%;
    padding:0 10px 10px 10px;
    overflow-y: auto;
    background: #fff;
    display: flex;
    flex-direction: column;
  }
  .el-checkbox__input.is-disabled+span.el-checkbox__label,.el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover{
    color: #9c9d9e !important;
  }
  .fp_flex{
    display: flex;
    justify-content: space-between;
  }
  .kpList .el-tabs__nav{
    width: 100% !important;
  }
  .kpList .el-tabs__active-bar{
    width: 50%!important;
  }
  .kpList .el-tabs__item{
    width: 50% !important;
    text-align: center;
  }
  .kpList section{
    flex: 1;
    overflow-y: auto;
  }
  .kpList .header{
    height: 50px;
  }
  .kpList footer{
    display: flex;
    justify-content: space-between;
  }
  .kpList .flex_p{
    display: flex;
    justify-content: space-between;
  }
  .kpList .list_card{
    border-bottom: 1px solid #e1e1e1;
    width: 100%;
    padding: 15px 0;
    /*display: flex;*/
    margin: 5px 0;
    /*align-items: center;*/
  }
  .kpList .list_card .el-checkbox__label{
    width: 92% !important;
  }
  .kpList .menuList{
    width: 100%;
    height: 30px;
    line-height: 30px;
    display: flex;
    justify-content: space-around;
    border-bottom: 1px solid #c1c1c1;
  }
  .kpList .menuList span{
    display: inline-block;
    width: 50%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/view/ywbl/dzfp/dkpList.vue